$jq.namespace('MatchCore.UI.Site');

MatchCore.UI.Site.Translate = function () {
    var _translationKeys;
    var retrieved = false;
    //To consume, Add key to Client Resource Controller
    var self = {
        getTranslation: function (key) {
            if (!embeddedTranslations && retrieved === false) {
                var url = '/ClientResource/GetTranslations/';
                if (MatchCore.Application) {
                    url = '/ClientResource/GetTranslations/?cc=' + MatchCore.Application.CultureCode;
                }
                $jq.ajax({
                    type: "GET",
                    url: url,
                    async: false,
                    cache: true,
                    success: function(response) {
                        _translationKeys = JSON.parse(response);
                        cb(_translationKeys[key]);
                        retrieved = true;
                    },
                    failure: function() {
                        // TODO : Add error handling
                        return '';
                    }
                });
            }
            if (!_translationKeys && embeddedTranslations) {
                _translationKeys = embeddedTranslations;
            }
            if (_translationKeys) {
                if (!_translationKeys[key] && console && console.log) {
                    console.log(key);
                }
                return _translationKeys[key];
            }
            console.log(key);
            return '';
        },
        
        stringFormat: function( str ,args) {
            
            var regex = new RegExp("{-?[0-9]+}", "g");

            return str.replace(regex, function (item) {
                var intVal = parseInt(item.substring(1, item.length - 1));
                var replace;
                if (intVal >= 0) {
                    replace = args[intVal];
                } else if (intVal === -1) {
                    replace = "{";
                } else if (intVal === -2) {
                    replace = "}";
                } else {
                    replace = "";
                }
                return replace;
            });
        }
    };
    
    return self;
}();